export default {
  pageSizeContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
};
